import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-aviso-numerado',
  templateUrl: './modal-aviso-numerado.component.html'
})
export class ModalAvisoNumeradoComponent {

  @Input() pageId;
  @Input() nameButton: string = 'Voltar';
  @Input() isOneButton: boolean = true;
  @Input() nameButtonConfirm: string = 'Sim';
  @Input() nameButtonCancel: string = 'Não';
  @Output() buttonConfirmSubmit = new EventEmitter();
  public title: string;
  public message: string;
  public messages: string[];  // Adicionamos esta linha

  constructor(
    public activeModal: NgbActiveModal,
    public router: Router
  ) { }

  public closeModal() {
    this.activeModal.close();
  }

  public submit() {
    this.buttonConfirmSubmit.emit(true);
    this.activeModal.close();
  }

}
